export const MIN_KLYDOS_FOR_COLLECTION = 12;
export const MIN_LABELS_FOR_COLLECTION = 2;
export const REQUIRED_THUMBNAIL_KLYDOS = 6;
